export default __webpack_public_path__ + "static/gb-numberplate-603c21ef833eff514e950271e5eb5b86.svg";